import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { Popup } from '@ow/comps'
import { CloseIcon } from '@ow/icons'
import Log from '../../log'

export default forwardRef((props, ref) => {
  const popupRef = useRef(null)
  const [currentData, setCurrentData] = useState({})

  const { tbs } = useAppEx()
  const { fields, getDitto, tbId } = useTbViewStore((state) =>
    pick(state, ['fields', 'getDitto', 'tbId'])
  )

  useImperativeHandle(ref, () => {
    return {
      open: (data) => {
        if (popupRef.current) {
          setCurrentData(data)
          popupRef.current.open()
        }
      },
      close: () => {
        if (popupRef.current) {
          popupRef.current.close()
        }
      },
    }
  })

  return (
    <Popup
      ref={popupRef}
      contentStyle={{
        height: '80vh',
        minHeight: '800px',
        marginTop: '10vh',
        borderRadius: '3px',
        background: '#fff',
      }}
    >
      <div className="p-5 flex flex-col gap-4" style={{ height: '80vh' }}>
        <div className="w-full flex items-center justify-between">
          <div
            className="text-primary-700 font-bold pb-2"
            style={{
              borderBottom: '1px solid var(--ow-color-neutral-200)',
            }}
          >
            操作日志
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              if (popupRef.current) {
                popupRef.current.close()
              }
            }}
          >
            <CloseIcon width={18} height={18} fill="currentColor" />
          </div>
        </div>
        <div
          className="overflow-y-auto px-3 gap-4 h-9/10"
          style={{ width: '25.5rem', height: '100%' }}
        >
          <Log
            data={currentData}
            fields={fields}
            getDitto={getDitto}
            tbs={tbs}
            tbId={tbId}
          />
        </div>
      </div>
    </Popup>
  )
})
